export default __webpack_public_path__ + "media/images/community/wordmark-dark-663b67336961cea887feed75afc97cb4.svg";